import { FileDocumentMinusOutlineIcon } from './FileDocumentMinusOutlineIcon';

/**
 * author: Simran
 * id 17759ECD-FE1E-446F-96C1-ED8C0F5EA783
 * name file-document-minus-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-minus-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileTextMinusOutlineIcon = FileDocumentMinusOutlineIcon;
export default FileTextMinusOutlineIcon